import defaultTemplate from 'text!./templates/address-summary-default.html';
import bigToSmallTemplate from 'text!./templates/address-summary-BigToSmall.html';
import postCodeBeforeCityTemplate from 'text!./templates/address-summary-PostCodeBeforeCity.html';

export default ['LocaleService', function (LocaleService) {
    var addressConfig = LocaleService.getAddressConfig();
    var template = void 0;

    switch (addressConfig.pcfMode) {
        case 'BigToSmall':
            template = bigToSmallTemplate;
            break;
        case 'PostCodeBeforeCity':
            template = postCodeBeforeCityTemplate;
            break;
        default:
            template = defaultTemplate;
            break;
    }

    return {
        restrict: 'AE',
        template: template,
        scope: {
            address: '='
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/inputs/AddressSummary.js
// module id = 770
// module chunks = 0